// ANGULAR
import { inject, Injectable } from '@angular/core';

// SERVICES
import { WorkOrderAsyncService } from 'src/app/app-services-async/work-order-async.service';

// REDUX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  WHDndAssignmentStoreActionTypes,
  GetWHDndAssignmentDtoListWithParams,
  SetWHDndAssignmentDtoList,
} from './w-h-dnd-assignment-store.actions';

// RxJS 6
import { map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { WHHttpParams } from '@workheld/workheld-shared-lib';

@Injectable()
export class WHDndAssignmentStoreEffects {
  private actions$ = inject(Actions);
  private workOrderAsyncService = inject(WorkOrderAsyncService);

  getWHDndAssignmentDtoListWithParams$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        WHDndAssignmentStoreActionTypes.GetWHDndAssignmentDtoListWithParams,
      ),
      switchMap((action: GetWHDndAssignmentDtoListWithParams) => {
        const { targetParent, workOrderId, httpParams } = action.payload;
        return this.loadDndAssignments(targetParent, workOrderId, httpParams).pipe(
          map(
            (dndAssignmentDtoList: any[]) =>
              new SetWHDndAssignmentDtoList({
                dndAssignmentDtoList,
                loading: false,
                loaded: true,
                workOrderId,
                targetParent,
              }),
          ),
        );
      }),
    );
  });

  private loadDndAssignments(
    targetParent: string,
    workOrderId: string,
    httpParams?: WHHttpParams,
  ): Observable<any[]> {
    switch (targetParent) {
      case 'WORKER':
        return this.workOrderAsyncService.getWorkOrderWorkerAssignmentDtoList(
          workOrderId,
          httpParams,
        );
      case 'EQUIPMENT':
        return this.workOrderAsyncService.getWorkOrderEquipmentAssignmentDtoList(
          workOrderId,
          httpParams,
        );
      case 'TOOL':
        return this.workOrderAsyncService.getWorkOrderToolAssignmentDtoList(
          workOrderId,
          httpParams,
        );
      default:
        return of([]);
    }
  }
}
